require('./components/contents_show_movie.js');
